
import { defineComponent, ref, toRef, watch, onMounted } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZMultiSelect from "@/components/modals/forms/VZMultiSelect.vue";
import * as Yup from "yup";
import { Form, Field, ErrorMessage } from "vee-validate";
export default defineComponent({
  name: "form-Phone-modal",
  props: {
    id: { type: String, default: "kt_user_add_site" },
    showDialog: { type: Boolean, default: false },
    maxWidth: { type: String, default: "mw-650px", required: false },
    widthClass: { type: String, default: "width-500", required: false },
    heightClass: { type: String, default: "mh-510px", required: false },
    siteIdsOptions: { type: Array, required: true },
    roleOptions: { type: Array, required: true },
  },
  emits: ["close-add-modal", "modal-submit-data"],
  components: {
    VZMultiSelect,
    Form,
    Field,
    ErrorMessage,
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const showModalVal = toRef(props, "showDialog");
    const userSites = ref([]) as any;
    const siteRole = ref(null) as any;
    const addSiteRef = ref<null | HTMLFormElement>(null);
    const close = () => {
      emit("close-add-modal");
      userSites.value = [];
      siteRole.value = null;
      addSiteRef.value?.resetForm();
    };
    const submitData = () => {
      const dataToEmit = userSites.value.map((siteId) => {
        const roleId = siteRole.value; // Check if the id matches siteRole
        return { siteId, roleId };
      });
      emit("modal-submit-data", dataToEmit);
      userSites.value = [];
      siteRole.value = null;
    };
    let addSiteSchema = Yup.object().shape({
      site: Yup.array()
        .nullable()
        .min(1, t("common.sites") + " " + t("common.isRequired")),
      role: Yup.string()
        .nullable()
        .required(t("common.roles") + " " + t("common.isRequired")),
    });
    return {
      t,
      close,
      showModalVal,
      siteRole,
      userSites,
      submitData,
      addSiteSchema,
      addSiteRef,
    };
  },
});
